<template lang="pug">
.background
  .background-bl
    mgraph(:xRange="[0, 2]", :yRange="[0, 2]")
      mgraph-g(x="-.5", y="-1")
        g(:transform="`rotate(${rotation})`")
          mgraph-g(x="0", y="4")
            arrow.flow-arrow(
              v-for="(arrow, index) in arrows",
              :key="index",
              :o="arrow.position",
              :d="arrow.direction"
            )
  .background-tr
    mgraph(:xRange="[-2, 0]", :yRange="[-2, 0]", ref="graph-tr")
      mgraph-point(
        v-for="(circle, index) in circles",
        :key="index",
        x="0.02",
        y="-0.2",
        :r="circle.r",
        :fill="circle.color"
      )
</template>

<script>
import Animation from "../util/Animation.vue";
import Arrow from "./flow/Arrow";
import colors from "../util/colors.js";

export default {
  mixins: [Animation],
  components: {
    arrow: Arrow,
  },
  computed: {
    rotation() {
      return -(3 * this.time) / 1000;
    },
    circles() {
      const circles = [];
      const time = (0.4 * this.time) / 1000;
      const graph = this.$refs["graph-tr"];
      const width = graph ? graph.width : 100;
      for (let i = 0; i < 7; ++i) {
        const t = ((time + i) % 6) / 6;
        circles.push({
          color: (i % 2 == 0
            ? colors.blauw.mix(colors.wit, t)
            : colors.wit
          ).string(),
          r: 0.5 * width * t,
        });
      }
      circles.sort((a, b) => b.r - a.r);
      return circles;
    },
    arrows() {
      const tn = 30;
      const arrows = [];
      let start = 0;
      for (let r = 1.2; r < 2; r += 0.15) {
        start += 0.5;
        for (let ti = 0; ti < tn; ++ti) {
          const t = ((start + ti) / tn) * Math.PI * 2;
          const x = r * Math.sin(t);
          const y = r * Math.cos(t);
          const f = 0.15 / Math.hypot(x, y);
          arrows.push({
            position: [x, y],
            direction: [-y * f, x * f],
          });
        }
      }
      return arrows;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../util/colors.scss";

.background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.3;
  z-index: -1;

  .background-bl {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50vw;

    svg {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .background-tr {
    position: absolute;
    right: 0;
    top: 0;
    width: 50vw;

    svg {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .flow-arrow {
    fill: $ugent-blauw;
  }
}
</style>